import { Typography } from "@mui/material";
import React from "react";
import { TypographyProps } from "@mui/material/Typography/Typography";

type DKGridTitleProps = {
  dataTestId?: string;
  title: string;
  color?: TypographyProps["color"];
  minHeight?: TypographyProps["minHeight"];
  display?: TypographyProps["display"];
  flexDirection?: TypographyProps["flexDirection"];
  justifyContent?: TypographyProps["justifyContent"];
  marginBottom?: TypographyProps["marginBottom"];
  fontWeight?: TypographyProps["fontWeight"];
};
export const DKGridTitle = (props: DKGridTitleProps) => {
  const {
    dataTestId,
    title,
    color,
    minHeight,
    display,
    flexDirection,
    justifyContent,
    marginBottom,
    fontWeight = "bold",
  } = props;

  return (
    <Typography
      variant={"body1"}
      color={color}
      minHeight={minHeight}
      display={display}
      flexDirection={flexDirection}
      justifyContent={justifyContent}
      marginBottom={marginBottom}
      fontWeight={fontWeight}
      data-testid={dataTestId}
    >
      {title}
    </Typography>
  );
};
